import React, { useState, useMemo } from 'react';
import Masonry from 'react-masonry-component';
import { useMediaQuery } from 'react-responsive';

import { Breakpoint, Color, IconName, ItemsMosaicTheme } from '../../enums';
import { ArtworkMosaicItemDetails } from '../../interfaces';
import { UseState } from '../../types';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { Container, StyledArtworkMosaicItem, ImageElement, StyledBoxTitle, LikeIconContainer, StyledIcon } from './itemsMosaic.styled';
import { ItemsMosaicProps } from './itemsMosaic.types';

export const ItemsMosaic: React.FC<ItemsMosaicProps> = (props: ItemsMosaicProps): JSX.Element => {
  const { items, theme = ItemsMosaicTheme.Row, onLayoutComplete, className }: ItemsMosaicProps = props;
  const [hoveredButtonIndex, setHoveredButtonIndex]: UseState<number | null> = useState<number | null>(null);
  const isTablet: boolean = useMediaQuery({ query: Breakpoint.Tablet });
  const isSmallMobile: boolean = useMediaQuery({ query: Breakpoint.SmallMobile });

  const postsToShowInRow: number = useMemo(
    (): number => {
      if (theme === ItemsMosaicTheme.Mosaic) {
        return items.length;
      } else {
        return (isTablet && !isSmallMobile) ? 3 : 4;
      }
    },
    [isTablet, isSmallMobile, items.length]
  );

  return (
    <Container className={className}>
      <Masonry 
        className='masonry-grid' 
        onLayoutComplete={onLayoutComplete}
      >
        {items.slice(0, postsToShowInRow).map((item: ArtworkMosaicItemDetails, index: number): JSX.Element => (
          <StyledArtworkMosaicItem
            key={`${item.boxTitleDetails.itemName ?? ''}_${item.boxTitleDetails.author ?? ''}_${item.image.slice(-20)}_${index}`}
            ref={item.ref}
            id={`artwork-${index}`}
          >
            <MenuPosition {...item}>
              <ImageElement src={item.image} alt={item.boxTitleDetails.itemName} />
              <StyledBoxTitle boxTitleDetails={item.boxTitleDetails} />
            </MenuPosition>
            {item.onLikeClick && (
              <LikeIconContainer
                data-testid={`like-button-${index}`}
                onClick={item.onLikeClick}
                onPointerEnter={(): void => setHoveredButtonIndex(index)}
                onPointerLeave={(): void => setHoveredButtonIndex(null)}
              >
                <StyledIcon
                  name={item.isLiked ? IconName.FavouriteFilled : IconName.Favourite}
                  color={hoveredButtonIndex === index
                    ? (item.isLiked ? Color.White : Color.Orange)
                    : (item.isLiked ? Color.Orange : Color.White)}
                  size={20}
                />
              </LikeIconContainer>
            )}
          </StyledArtworkMosaicItem>
        ))}
      </Masonry>
    </Container>
  );
};
